export default __webpack_public_path__ + "static/media/css02.29f2a647.PNG";